// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} Acompanhamento
 * @property {number} Id - ID Ãºnico do acompanhamento
 * @property {number} [CargaId] - ID da carga associada
 * @property {string} Titulo - TÃ­tulo do acompanhamento
 * @property {string} Descricao - DescriÃ§Ã£o do acompanhamento
 * @property {string} [Status] - Campo descontinuado
 * @property {number[]} UsuariosNotificar - IDs dos usuÃ¡rios para notificar
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {string} DataModificacao - Data de modificaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 * @property {number} UsuarioModificacao - ID do usuÃ¡rio que modificou
 */
/**
 * @typedef {Object} AcompanhamentoCreatePayload
 * @property {number} [CargaId] - ID da carga associada
 * @property {string} Titulo - TÃ­tulo do acompanhamento
 * @property {string} Descricao - DescriÃ§Ã£o do acompanhamento
 * @property {string} [Status] - Campo descontinuado
 * @property {number[]} [UsuariosNotificar] - IDs dos usuÃ¡rios para notificar
 */
/**
 * @typedef {Object} AcompanhamentoFilters
 * @property {string} [Status] - Campo descontinuado
 * @property {number} [CargaId] - Filtro por ID da carga
 * @property {string} [Search] - Busca por tÃ­tulo ou descriÃ§Ã£o
 * @property {number} [Limit] - Limite de registros
 * @property {number} [Offset] - Offset para paginaÃ§Ã£o
 */
/**
 * @typedef {Object} AcompanhamentoMensagem
 * @property {number} Id - ID Ãºnico da mensagem
 * @property {number} AcompanhamentoId - ID do acompanhamento
 * @property {string} Mensagem - ConteÃºdo da mensagem
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 * @property {string} NomeUsuario - Nome do usuÃ¡rio
 */
/**
 * @typedef {Object} AcompanhamentoAnexo
 * @property {number} Id - ID Ãºnico do anexo
 * @property {number} AcompanhamentoId - ID do acompanhamento
 * @property {string} NomeArquivo - Nome do arquivo
 * @property {string} UrlArquivo - URL do arquivo
 * @property {string} TipoArquivo - Tipo do arquivo
 * @property {number} TamanhoArquivo - Tamanho do arquivo em bytes
 * @property {string} DataCriacao - Data de criaÃ§Ã£o
 * @property {number} UsuarioCriacao - ID do usuÃ¡rio que criou
 */
/**
 * Lista todos os acompanhamentos
 * @param {AcompanhamentoFilters} filters - Filtros para a busca
 * @returns {Promise<Acompanhamento[]>} Lista de acompanhamentos
 */
export const getAcompanhamentos = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    // Adicionar filtros apenas se tiverem valor
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/acompanhamentos?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || [];
};
/**
 * Busca um acompanhamento especÃ­fico por ID
 * @param {number} id - ID do acompanhamento
 * @returns {Promise<Acompanhamento>} Dados do acompanhamento
 */
export const getAcompanhamentoById = async (id) => {
    const response = await get(`${API_URL}/acompanhamentos/${id}`);
    return response?.data || response;
};
/**
 * Busca um acompanhamento especÃ­fico por ID (alias para getAcompanhamentoById)
 * @param {number} id - ID do acompanhamento
 * @returns {Promise<Acompanhamento>} Dados do acompanhamento
 */
export const getAcompanhamento = async (id) => {
    const response = await get(`${API_URL}/acompanhamentos/${id}`);
    return response?.data || response;
};
/**
 * Busca acompanhamentos por carga
 * @param {number} cargaId - ID da carga
 * @param {string} [status] - Filtro por status
 * @returns {Promise<Acompanhamento[]>} Lista de acompanhamentos da carga
 */
export const getAcompanhamentosByCarga = async (cargaId, status = null, options = {}) => {
    const queryParams = new URLSearchParams();
    // Filtro de status removido do backend
    if (options.pagina !== undefined) {
        queryParams.append(key, String(value));
    }
    if (options.quantidadePorPagina !== undefined) {
        queryParams.append(key, String(value));
    }
    const url = `${API_URL}/acompanhamentos/carga/${cargaId}?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || [];
};
/**
 * Cria um novo acompanhamento
 * @param {AcompanhamentoCreatePayload} payload - Dados do acompanhamento
 * @returns {Promise<Acompanhamento>} Acompanhamento criado
 */
export const createAcompanhamento = async (payload) => {
    const response = await post(`${API_URL}/acompanhamentos`, payload);
    return response?.data || response;
};
/**
 * Atualiza um acompanhamento existente
 * @param {number} id - ID do acompanhamento
 * @param {AcompanhamentoCreatePayload} payload - Dados atualizados
 * @returns {Promise<Acompanhamento>} Acompanhamento atualizado
 */
export const updateAcompanhamento = async (id, payload) => {
    const response = await put(`${API_URL}/acompanhamentos/${id}`, payload);
    return response?.data || response;
};
/**
 * Exclui um acompanhamento
 * @param {number} id - ID do acompanhamento a ser excluÃ­do
 * @returns {Promise<void>}
 */
export const deleteAcompanhamento = async (id) => {
    await deleteRequest(`${API_URL}/acompanhamentos/${id}`);
};
/**
 * Busca mensagens de um acompanhamento
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @returns {Promise<AcompanhamentoMensagem[]>} Lista de mensagens
 */
export const getMensagensAcompanhamento = async (acompanhamentoId) => {
    const response = await get(`${API_URL}/acompanhamentos/${acompanhamentoId}/mensagens`);
    return response?.data || response || [];
};
/**
 * Adiciona uma mensagem a um acompanhamento
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {string} mensagem - ConteÃºdo da mensagem
 * @returns {Promise<AcompanhamentoMensagem>} Mensagem criada
 */
export const addMensagemAcompanhamento = async (acompanhamentoId, mensagem) => {
    const response = await post(`${API_URL}/acompanhamentos/${acompanhamentoId}/mensagens`, { mensagem });
    return response?.data || response;
};
/**
 * Cria uma nova mensagem com anexo
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {FormData} formData - Dados da mensagem e arquivo
 * @returns {Promise<AcompanhamentoMensagem>} Mensagem criada
 */
export const createMensagem = async (acompanhamentoId, formData) => {
    const response = await post(`${API_URL}/acompanhamentos/${acompanhamentoId}/mensagens`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data || response;
};
/**
 * Atualiza uma mensagem existente
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {number} mensagemId - ID da mensagem
 * @param {Object} payload - Dados atualizados
 * @returns {Promise<AcompanhamentoMensagem>} Mensagem atualizada
 */
export const updateMensagem = async (acompanhamentoId, mensagemId, payload) => {
    const response = await put(`${API_URL}/acompanhamentos/${acompanhamentoId}/mensagens/${mensagemId}`, payload);
    return response?.data || response;
};
/**
 * Exclui uma mensagem
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {number} mensagemId - ID da mensagem
 * @returns {Promise<void>}
 */
export const deleteMensagem = async (acompanhamentoId, mensagemId) => {
    await deleteRequest(`${API_URL}/acompanhamentos/${acompanhamentoId}/mensagens/${mensagemId}`);
};
/**
 * Busca anexos de um acompanhamento
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @returns {Promise<AcompanhamentoAnexo[]>} Lista de anexos
 */
export const getAnexosAcompanhamento = async (acompanhamentoId) => {
    const response = await get(`${API_URL}/acompanhamentos/${acompanhamentoId}/anexos`);
    return response?.data || response || [];
};
/**
 * Adiciona um anexo a um acompanhamento
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {FormData} formData - Dados do arquivo
 * @returns {Promise<AcompanhamentoAnexo>} Anexo criado
 */
export const addAnexoAcompanhamento = async (acompanhamentoId, formData) => {
    const response = await post(`${API_URL}/acompanhamentos/${acompanhamentoId}/anexos`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data || response;
};
/**
 * Remove um anexo de um acompanhamento
 * @param {number} acompanhamentoId - ID do acompanhamento
 * @param {number} anexoId - ID do anexo
 * @returns {Promise<void>}
 */
export const removeAnexoAcompanhamento = async (acompanhamentoIdOrAnexoId, maybeAnexoId) => {
    const anexoId = maybeAnexoId ?? acompanhamentoIdOrAnexoId;
    await deleteRequest(`${API_URL}/acompanhamentos/anexos/${anexoId}`);
};
/**
 * ObtÃ©m estatÃ­sticas de acompanhamentos
 * @returns {Promise<Object>} EstatÃ­sticas de acompanhamentos
 */
export const getEstatisticasAcompanhamentos = async () => {
    const response = await get(`${API_URL}/acompanhamentos/estatisticas`);
    return response?.data || response || {};
};
